/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FlagIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABBklEQVR4nO2Vz2rCQBDG8wYeLFR9G7GnkvkTYZ0JxWs9aQ99hkIfwIO+jAerDyPFXIsoRCYi5LDR2GAvzcCcdvb7sct+3wbBXxWwrpHky7cWRS9txMETRjoBkimyfgLo400AZE2tQ5JeJsQyMyCyJOe1fAPr4leAsg2kB5/Os3Mt51yjMgBzp0XWef60QLoDltfKALzY8n1ngKY1IK2vKPWYawskm8qvKBNiXVpcAOnYDGUOtTkgfS/p9K0XcBbyxgkOukjyUwKwJ4pHXkCROLD0baPHsQmSrrK4YHmz1GUeNguzqAgQhvEDsn6c4vokhKidovmbAZWrBlwt+zDs7V+fDP5ZHQEjzSH/KFu4mwAAAABJRU5ErkJggg==)
 */
export const FlagIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3 1a1 1 0 0 1 1 1v.82l8.67-1.45A2 2 0 0 1 15 3.35v1.47l5.67-.95A2 2 0 0 1 23 5.85v7.3a2 2 0 0 1-1.67 1.98l-9 1.5a2 2 0 0 1-1.78-.6c-.2-.21-.08-.54.18-.68a5.01 5.01 0 0 0 1.94-1.94c.18-.32-.1-.66-.46-.6L4 14.18V21a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
